export default __webpack_public_path__ + "static/media/ic_glp_24.1e67331c.svg";